import QueryTypes from 'services/api/QueryTypes'
import { BaseHttpService } from '../BaseHttpService'
import { AltenarConverter } from './AltenarConverter'

class AltenarApi extends BaseHttpService {
  private converter

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/integrations/bab0433b`
    this.converter = new AltenarConverter()
  }

  getToken = () =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/login`,
      converterSuccess: this.converter.convertToken,
    })
}

export default AltenarApi
